import {useEffect} from "react";
import {useUnreadNotificationCount} from "@/data/notification-hooks";
import {setAppBadgeCount} from "@/lib/app-badge";

/**
 * Keeps the OS app-icon badge equal to the unread count for as long as a user is logged in.
 *
 * The backend already stamps a badge on every push, so the icon is correct while the app is
 * closed. What it cannot do is take the badge down once the user has read something, which is
 * exactly what this covers: the mark-read mutations write the server's recounted total into the
 * same query this reads, so clearing the inbox clears the icon without another request.
 *
 * A not-yet-known count is skipped rather than treated as zero — writing 0 on every cold start
 * would wipe the badge a push had legitimately set, before the real number had a chance to arrive.
 */
export function useAppBadgeSync() {
    const unreadCount = useUnreadNotificationCount();

    useEffect(() => {
        if (unreadCount === undefined) {
            return;
        }
        void setAppBadgeCount(unreadCount);
    }, [unreadCount]);
}
